module.exports = __webpack_public_path__ + "static/media/pretreat.0b38ce56.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/room/rooms/devices/pretreat.png
// module id = 28
// module chunks = 0